import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgChevronDown(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.7108 8.71294C19.3201 8.32241 18.6867 8.32241 18.296 8.71294L12.0038 15.002L5.71161 8.71294C5.32092 8.32241 4.68749 8.32241 4.2968 8.71294C3.90611 9.10346 3.90611 9.73663 4.2968 10.1272L10.589 16.4163C11.3704 17.1973 12.6372 17.1973 13.4186 16.4163L19.7108 10.1272C20.1015 9.73663 20.1015 9.10346 19.7108 8.71294Z", fill: "currentColor" })));
}
export default SvgChevronDown;
